// components
import CommonPaginatedTable from "../../Common/CommonPaginatedTable";
import SubscriberSmallProfile from "../../Profile/SubscriberSmallProfile";
import BaseApi from "../../../utils/BaseApi";
import CommonActionModal from "../../Common/CommonActionModal";

// icons
import TableViewIcon from "@mui/icons-material/TableView";


class RoadRunnerListModal extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: TableViewIcon,
            buttonLabel: 'Список лучших результатов',
            buttonColor: 'primary',
            ready: true,
        })
    }

    async retrieveResults() {
        const url = 'game_result/';
        const api = new BaseApi();
        let params = {
            game: 'road_runner',
            page_size: 20,
        }
        let response = await api.get(url, params);
        return response.data.results
    }

    async beforeModalOpen(){
        let data = await this.retrieveResults()
        return {
            modalLabel: 'Список лучших результатов',
            modalIcon: TableViewIcon,
            mainComponent: CommonPaginatedTable,
            mainComponentProps: {
                data: data,
                fields: [
                    {
                        title: 'Игрок',
                        component: SubscriberSmallProfile,
                        componentProps: {
                            componentObjKey: 'subscriber'
                        },
                        visible: true,
                    },
                    {
                        title: 'Результат',
                        name: 'result',
                        visible: true,
                    },
                    {
                        title: 'Дата',
                        name: 'created_on',
                        visible: true,
                    },
                ],
            },
        }
    }
}

export default RoadRunnerListModal
